export enum TOPIC_FULLSCREEN {
  RACK = "RACK",
  TROLLEY = "TROLLEY"
}